import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';
import { getBrandDomain } from '../../../../../common/utils/getBrandDomain';

export default function Status() {
    const brandDomain = getBrandDomain();
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark status</span>
                    <span className={Styles.CommandSummary}>Show authentication status</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Displays the current authentication status and user information.
                        Use this to verify you're logged in before running serve.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Aliases</div>
                        <div className={Styles.CodeBlock}>
                            <code>modelpark whoami</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Options</div>
                        <table className={Styles.OptionsTable}>
                            <thead>
                                <tr>
                                    <th>Flag</th>
                                    <th>Default</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>--server</td>
                                    <td>{`https://${brandDomain}`}</td>
                                    <td>Server URL for authentication check</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output (authenticated)</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`Authenticated
  Email:  user@example.com
  User:   username
  Server: https://${brandDomain}
  Source: config file
  Config: /home/user/.modelpark/config.json`}</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output (not authenticated)</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`Not logged in
  Server: https://${brandDomain}

Run 'modelpark login' to authenticate`}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
